/* MD Productos relacionados: flechas del carrusel (scroll y snap nativos) y carga de las
   recomendaciones de Shopify, que se colocan por delante de los productos de la colección */
(function () {
  'use strict';

  /* Limpieza por instancia (observer o listener de resize) para el evento unload del editor */
  var cleanups = new WeakMap();

  function initCarousel(container) {
    var previous = cleanups.get(container);
    if (previous) {
      previous();
      cleanups.delete(container);
    }

    var track = container.querySelector('.md-productos-relacionados__track');
    var prev = container.querySelector('.md-productos-relacionados__arrow--prev');
    var next = container.querySelector('.md-productos-relacionados__arrow--next');
    if (!track || !prev || !next) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Un paso = una tarjeta más su separación */
    function step() {
      var slide = track.querySelector('.md-productos-relacionados__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    /* aria-disabled en vez de disabled: la flecha no pierde el foco de teclado al llegar al extremo */
    function setDisabled(button, disabled) {
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var scrollable = maxScroll > 1;
      container.classList.toggle('md-productos-relacionados--scrollable', scrollable);
      setDisabled(prev, track.scrollLeft <= 1);
      setDisabled(next, track.scrollLeft >= maxScroll - 1);
    }

    /* Una sola lectura de layout por frame durante el scroll o el resize */
    var pending = false;
    function scheduleUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        update();
      });
    }

    function move(direction) {
      return function () {
        if (this.getAttribute('aria-disabled') === 'true') return;
        track.scrollBy({
          left: direction * step(),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      };
    }

    var onPrev = move(-1);
    var onNext = move(1);
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    track.addEventListener('scroll', scheduleUpdate, { passive: true });

    var observer = null;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(scheduleUpdate);
      observer.observe(track);
    } else {
      window.addEventListener('resize', scheduleUpdate);
    }

    cleanups.set(container, function () {
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
      track.removeEventListener('scroll', scheduleUpdate);
      if (observer) observer.disconnect();
      else window.removeEventListener('resize', scheduleUpdate);
    });

    update();
  }

  /* Pide la sección renderizada por la Product Recommendations API (misma tienda, mismo tema)
     y fusiona sus tarjetas con las ya presentes: recomendaciones primero, sin repetir productos,
     hasta el límite configurado. Los nodos proceden del HTML que devuelve el propio tema. */
  function loadRecommendations(container) {
    var url = container.dataset.url;
    if (!url || container.dataset.fetched) return;
    container.dataset.fetched = 'true';

    var limit = parseInt(container.dataset.limit, 10) || 16;

    window.fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Respuesta ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.md-productos-relacionados');
        if (!fresh || fresh.dataset.source !== 'recomendaciones') return;

        var track = container.querySelector('.md-productos-relacionados__track');
        var freshSlides = fresh.querySelectorAll('.md-productos-relacionados__slide');
        if (!track || !freshSlides.length) return;

        var merged = [];
        var seen = {};
        var i;

        for (i = 0; i < freshSlides.length && merged.length < limit; i++) {
          var id = freshSlides[i].dataset.productId;
          if (!id || seen[id]) continue;
          seen[id] = true;
          merged.push(document.importNode(freshSlides[i], true));
        }

        var current = track.querySelectorAll('.md-productos-relacionados__slide');
        for (i = 0; i < current.length && merged.length < limit; i++) {
          var currentId = current[i].dataset.productId;
          if (!currentId || seen[currentId]) continue;
          seen[currentId] = true;
          merged.push(current[i]);
        }

        while (track.firstChild) track.removeChild(track.firstChild);
        for (i = 0; i < merged.length; i++) track.appendChild(merged[i]);
        container.dataset.source = 'recomendaciones';
        container.classList.remove('md-productos-relacionados--empty');
        track.scrollLeft = 0;
        initCarousel(container);
      })
      .catch(function () {
        /* Sin recomendaciones (o sección no disponible en el editor): se mantienen los productos de la colección */
      });
  }

  /* La sección va bajo el pliegue: la petición se lanza al acercarse al viewport para no competir
     con la imagen principal de la ficha en la carga inicial */
  function loadWhenNear(container) {
    if (!container.dataset.url || container.dataset.fetched) return;
    if (!('IntersectionObserver' in window)) {
      loadRecommendations(container);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        observer.disconnect();
        loadRecommendations(container);
        return;
      }
    }, { rootMargin: '600px 0px' });
    observer.observe(container);
  }

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';
    initCarousel(container);
    loadWhenNear(container);
  }

  function destroySection(container) {
    var cleanup = cleanups.get(container);
    if (cleanup) {
      cleanup();
      cleanups.delete(container);
    }
    delete container.dataset.mdInit;
  }

  var sections = document.querySelectorAll('.md-productos-relacionados');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.md-productos-relacionados');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.md-productos-relacionados');
    if (section) destroySection(section);
  });
})();
